import { css } from 'styled-components'

import reset from './reset'
import {
  breakpoints,
  colorToken,
  designToken,
  fontsizeToken,
  pixelToVwBy375,
  spacingToken,
} from './tokens'

/**
 * @therich-team/design-system v0.1.36 의 globalStyle 을 그대로 내재화한 것.
 * (reset + :root 변수 + body 기본 스타일) 선언 순서·값이 기존 화면 치수를 결정하므로 수정 금지.
 */

const spacing = css`
  ${spacingToken.css.desktop}

  ${breakpoints.mobile} {
    ${spacingToken.css.mobile}
  }
`

const border = css`
  --border-radius-6: 0.6rem;
  --border-radius-12: 1.2rem;
  --border-radius-25: 2.5rem;

  ${breakpoints.mobile} {
    --border-radius-6: ${pixelToVwBy375(6)};
    --border-radius-12: ${pixelToVwBy375(12)};
    --border-radius-25: ${pixelToVwBy375(25)};
  }
`

const typography = css`
  ${fontsizeToken.css.desktop};

  ${breakpoints.mobile} {
    ${fontsizeToken.css.mobile};
  }
`

const colors = css`
  /* theme */
  :root {
    &.light {
      ${colorToken.css.light}
    }
    &.dark {
      ${colorToken.css.dark}
    }
    :not(.light):not(.dark) {
      @media (prefers-color-scheme: light) {
        ${colorToken.css.light}
      }
      @media (prefers-color-scheme: dark) {
        ${colorToken.css.dark}
      }
    }
  }
`

export const globalStyle = css`
  ${reset}

  :root {
    font-size: 62.5%;
    color: ${colorToken.withVar.grayscale.gray50};

    ${spacing}
    ${border}
    ${typography}
    ${colors}
  }

  body {
    /* bg color */
    background-color: ${colorToken.withVar.primary.navy800};

    * {
      font-family: ${designToken.fontFamilies['apple-sd-gothic-neo']};
    }
  }
`
